//@ts-nocheck
// Importing Chakra UI toast components and utilities
import {
  Toaster as ChakraToaster,
  Portal,
  Spinner,
  Stack,
  Toast,
  createToaster
} from '@chakra-ui/react';

/*
 * This file defines a reusable toast notification system.
 * It's based on Chakra UI's `createToaster` and customized with default settings.
 */

// Create a toaster instance with global default configuration
export const toaster = createToaster({
  overlap: true,                 // Show toasts on top of each other
  placement: 'top-end',          // Position on the screen where the toast will appear
  pauseOnPageIdle: true,         // Toast won't auto-dismiss if user is inactive (no mouse/keyboard)
  pauseOnHover: true,            // Keeps the toast open if the user hovers over it
  pauseOnFocusLoss: true,        // Prevents dismiss if user switches to another browser tab
  animation: 'slide',            // Slide animation for appearance/disappearance
  duration: 5000,                // Toast stays visible for 5 seconds by default
  max: 5,                        // Max number of toasts visible at once (oldest will dismiss if full)
  action: {                      // Default action button shown on all toasts
    label: 'OK',
    onClick: () => {}            // No-op by default — you can override this per toast
  }
});

/*
 * `Toaster` component must be mounted somewhere in your app (usually near the root).
 * It renders the actual toast notifications based on the `toaster` above.
 */
export const Toaster = () => {
  return (
    <Portal> {/* Ensures toast appears outside normal DOM flow (like a modal) */}
      <ChakraToaster toaster={toaster} insetInline={{ mdDown: '4' }}>
        {(toast) => (
          <Toast.Root width={{ md: 'sm' }}> {/* Toast container styling */}
            
            {/* Show a spinner only for "loading" type toasts */}
            {toast.type === 'loading' ? (
              <Spinner size="sm" color="blue.solid" />
            ) : (
              <Toast.Indicator /> // Default icon for info/success/error types
            )}
            
            {/* Toast text content: title and description */}
            <Stack gap="1" flex="1" maxWidth="100%">
              {toast.title && <Toast.Title>{toast.title}</Toast.Title>}
              {toast.description && (
                <Toast.Description>{toast.description}</Toast.Description>
              )}
            </Stack>

            {/* Optional action button, if one is defined */}
            {toast.action && (
              <Toast.ActionTrigger>{toast.action.label}</Toast.ActionTrigger>
            )}

            {/* Close button, shown only if toast is configured as closable */}
            {toast.meta?.closable && <Toast.CloseTrigger />}
          </Toast.Root>
        )}
      </ChakraToaster>
    </Portal>
  );
};
